import { CircularProgress, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { fromISO8601 } from "../../../utils/iso8601";
import { constructCloudflareStreamUrl } from "../utils";

import type { Asset } from "../server/digital-asset-service";
import type { FC } from "react";

// Cloudflare Stream needs a moment after upload before the player can show the video
const PROCESSING_MS = 15_000;

export const VideoAssetPreview: FC<{ asset: Asset }> = ({ asset }) => {
  const readyAt = asset.created_at
    ? fromISO8601(asset.created_at).getTime() + PROCESSING_MS
    : undefined;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (readyAt === undefined) return undefined;
    const timeout = setTimeout(() => setNow(readyAt), readyAt - Date.now());
    return () => clearTimeout(timeout);
  }, [readyAt]);

  if (!asset.external_storage_id || readyAt === undefined) {
    return null;
  }

  const isVideoProcessingComplete = now >= readyAt;

  if (!isVideoProcessingComplete) {
    return (
      <Stack sx={{ alignItems: "center", gap: 2 }}>
        <CircularProgress />
        <Typography variant="body2">Processing...</Typography>
      </Stack>
    );
  }

  return (
    // oxlint-disable-next-line react/iframe-missing-sandbox -- Cloudflare Stream player; needs the listed `allow` features and full-screen
    <iframe
      src={`${constructCloudflareStreamUrl(asset.external_storage_id)}/iframe`}
      allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
      allowFullScreen
      title="Video Preview"
      width="480"
      height="270"
    />
  );
};
